import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section id="home" className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20retail%20collage%20featuring%20neatly%20arranged%20sneakers%20denim%20jackets%20cotton%20tshirts%20leather%20bags%20and%20accessories%20on%20warm%20cream%20surface%2C%20soft%20morning%20daylight%20streaming%20from%20left%20side%2C%20scandinavian%20minimalist%20aesthetic%2C%20gentle%20natural%20shadows%2C%20warm%20beige%20and%20ivory%20tones%2C%20professional%20editorial%20product%20photography%20with%20organic%20textures%2C%20clean%20harmonious%20arrangement&width=1600&height=900&seq=hero-main-v2-2026&orientation=landscape"
        alt="ACBuySpreadsheet buying system background"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center pt-16">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight tracking-wide uppercase">
          ACBuySpreadsheet
        </h1>
        <p className="text-xl md:text-2xl text-white/90 font-light mt-4 md:mt-5">
          Smart Buying System
        </p>
        <p className="text-sm md:text-base text-white/70 mt-4 md:mt-6 max-w-[600px] mx-auto leading-relaxed">
          A powerful spreadsheet-based buying and order tracking system designed for speed,
          accuracy, and simplified purchasing workflow.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8 md:mt-10">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-full cursor-pointer transition-all duration-200 whitespace-nowrap"
          >
            buy it now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 backdrop-blur-sm hover:bg-white/25 text-white font-medium text-sm rounded-full border border-white/25 cursor-pointer transition-all duration-200 whitespace-nowrap"
          >
            acbuy spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line"></i>
            </span>
          </a>
        </div>

        <div className="mt-14 md:mt-16">
          <button
            onClick={() => {
              const el = document.getElementById("categories");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex flex-col items-center gap-2 text-white/60 hover:text-white/90 transition-colors cursor-pointer"
          >
            <span className="text-xs uppercase tracking-widest">Explore Categories</span>
            <span className="w-5 h-5 flex items-center justify-center animate-bounce">
              <i className="ri-arrow-down-line text-lg"></i>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}